"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

exports.SearchUnit = function (props) {
  var _react_1$default$useS = react_1.default.useState(props.value || ''),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      value = _react_1$default$useS2[0],
      setValue = _react_1$default$useS2[1];

  var name = props.name,
      onChange = props.onChange,
      placeholder = props.placeholder;

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    var v = {
      name: String(name),
      value: value
    };
    setValue(value);
    onChange(v);
  };

  return react_1.default.createElement(TextField_1.default, {
    name: String(name),
    value: value,
    onChange: handleChange,
    placeholder: placeholder
  });
};